import { styled } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { SVGProps } from "react";

interface IgniteLogoOwnProps {
    variant?: "full" | "symbol";
    size?: "xsmall" | "small" | "medium" | "large" | "xlarge" | "2xlarge";
    color?: "brand" | "secondary";
}

const igniteLogoClasses = {
    root: "IgniteLogo-root",
    colorPrimary: "IgniteLogo-colorPrimary",
    colorSecondary: "IgniteLogo-colorSecondary",
    text: "IgniteLogo-text",
    icon: "IgniteLogo-icon",
} as const;

function FullSvgComponent(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 128 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <title>Ignite</title>
            <g className={igniteLogoClasses.icon}>
                <path
                    d="M20.7617 13.3083C24.4342 13.3083 27.4114 10.3291 27.4114 6.65414C27.4114 2.97916 24.4342 0 20.7617 0C17.0892 0 14.112 2.97916 14.112 6.65414C14.112 10.3291 17.0892 13.3083 20.7617 13.3083Z"
                    className={igniteLogoClasses.colorPrimary}
                />
                <path
                    d="M26.6768 21.2945C26.6768 22.2317 26.6768 22.6988 26.8514 23.1207C27.0261 23.5426 27.3544 23.8711 28.0169 24.5341C28.8783 25.396 29.589 26.1075 30.8418 27.3612C31.4532 27.973 31.7604 28.2804 31.9772 28.416C33.3144 29.2598 35.0822 28.5275 35.4316 26.9845C35.4888 26.7343 35.4888 26.3004 35.4888 25.4355C35.4888 25.0346 35.4888 24.8327 35.5129 24.664C35.6605 23.6665 36.4435 22.8859 37.4373 22.7382C37.606 22.7141 37.8048 22.7141 38.2083 22.7141C39.0757 22.7141 39.5063 22.7141 39.7563 22.6569C41.2983 22.3073 42.0301 20.5383 41.1868 19.2002C41.0513 18.9832 40.7441 18.6789 40.1328 18.0641L37.3109 15.24C36.6483 14.577 36.3171 14.2455 35.8984 14.0737C35.4768 13.899 35.01 13.899 34.0734 13.899H31.2575C29.0981 13.899 28.02 13.899 27.3484 14.571C26.6768 15.243 26.6768 16.3219 26.6768 18.4827V21.3005V21.2945Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M14.865 17.1295C14.865 16.1923 14.865 15.7252 14.6903 15.3033C14.5157 14.8813 14.1874 14.5529 13.5248 13.8899C12.6635 13.0279 11.9528 12.3165 10.7 11.0628C10.0886 10.451 9.7814 10.1436 9.56456 10.008C8.22738 9.16419 6.45954 9.89651 6.11019 11.4395C6.05297 11.6896 6.05297 12.1236 6.05297 12.9885C6.05297 13.3893 6.05297 13.5912 6.02888 13.76C5.88131 14.7575 5.09828 15.5381 4.10443 15.6857C3.93578 15.7098 3.73701 15.7098 3.33345 15.7098C2.46609 15.7098 2.03542 15.7098 1.78545 15.7671C0.243488 16.1167 -0.488345 17.8857 0.354919 19.2238C0.490443 19.4407 0.797632 19.7451 1.409 20.3599L4.23085 23.184C4.89341 23.847 5.2247 24.1785 5.64332 24.3502C6.06495 24.525 6.53175 24.525 7.46838 24.525H10.2843C12.4436 24.525 13.5218 24.525 14.1934 23.853C14.865 23.1809 14.865 22.1021 14.865 19.9413V17.1235V17.1295Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M18.6868 25.1248C17.7502 25.1248 17.2834 25.1248 16.8617 25.2996C16.4401 25.4744 16.1118 25.8029 15.4493 26.4659C14.5879 27.3278 13.8772 28.0393 12.6244 29.2929C12.013 29.9047 11.7058 30.2121 11.5703 30.4291C10.727 31.7672 11.4589 33.5362 13.0008 33.8858C13.2508 33.943 13.6845 33.943 14.5488 33.943C14.9494 33.943 15.1512 33.943 15.3198 33.9671C16.3167 34.1148 17.0967 34.8983 17.2443 35.8928C17.2684 36.0616 17.2684 36.2605 17.2684 36.6643C17.2684 37.5323 17.2684 37.9632 17.3256 38.2134C17.6749 39.7563 19.4428 40.4887 20.78 39.6448C20.9968 39.5092 21.301 39.2018 21.9153 38.5901L24.7372 35.766C25.3998 35.103 25.731 34.7715 25.9027 34.3526C26.0774 33.9307 26.0774 33.4636 26.0774 32.5263V29.7086C26.0774 27.5478 26.0774 26.4689 25.4058 25.7969C24.7342 25.1248 23.656 25.1248 21.4967 25.1248H18.6808H18.6868Z"
                    className={igniteLogoClasses.colorSecondary}
                />
            </g>
            <g className={igniteLogoClasses.text}>
                <path
                    d="M53.081 11.9073C51.4115 11.9073 50.2278 10.6324 50.2278 9.08444C50.2278 7.50609 51.4115 6.23126 53.081 6.23126C54.7504 6.23126 55.9645 7.50609 55.9645 9.08444C55.9645 10.6324 54.7504 11.9073 53.081 11.9073ZM55.3878 28.0571C55.3878 28.2835 55.3878 28.3967 55.3175 28.467C55.2471 28.5373 55.1339 28.5373 54.9075 28.5373H51.2544C51.028 28.5373 50.9148 28.5373 50.8445 28.467C50.7741 28.3967 50.7741 28.2835 50.7741 28.0571V14.3874C50.7741 14.161 50.7741 14.0478 50.8445 13.9775C50.9148 13.9072 51.028 13.9072 51.2544 13.9072H54.9075C55.1339 13.9072 55.2471 13.9072 55.3175 13.9775C55.3878 14.0478 55.3878 14.161 55.3878 14.3874V28.0571Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M68.1846 14.6782C68.6714 15.0784 68.9147 15.2784 69.002 15.2777C69.0865 15.2769 69.1298 15.2564 69.184 15.1916C69.24 15.1247 69.24 14.8483 69.24 14.2954C69.24 14.1571 69.24 14.088 69.2676 14.0355C69.2902 13.9925 69.3253 13.9574 69.3683 13.9348C69.4208 13.9072 69.4899 13.9072 69.6283 13.9072H73.4037C73.6301 13.9072 73.7433 13.9072 73.8137 13.9775C73.884 14.0478 73.884 14.161 73.884 14.3874V27.5964C73.8536 30.4192 72.852 32.5136 71.0612 33.758C69.7256 34.699 67.9348 35.0632 65.8405 35.0632C63.7461 35.0632 61.9856 34.7293 60.5591 33.8794C59.2278 33.0644 58.237 31.7144 58.0002 30.3082C57.9636 30.0909 57.9453 29.9823 58.0173 29.8972C58.0892 29.8121 58.2087 29.8121 58.4478 29.8121H62.2839C62.4634 29.8121 62.5531 29.8121 62.6146 29.8545C62.6761 29.8969 62.7143 29.997 62.7906 30.1971C63.1421 31.119 64.1175 31.6637 65.7798 31.6637C67.9348 31.6637 69.24 30.7227 69.24 28.1124C69.24 27.3941 69.24 27.0349 69.1332 26.9636C69.1171 26.9528 69.1099 26.949 69.092 26.9416C68.9734 26.8923 68.6285 27.1225 67.9387 27.5828C67.028 28.1906 65.8366 28.5373 64.6567 28.5373C60.3162 28.5373 57.7059 25.3806 57.7059 21.0705C57.7059 16.7604 60.4983 13.5126 64.7174 13.5126C66.0508 13.5126 67.2901 13.9429 68.1846 14.6782ZM65.9315 24.9557C68.1473 24.9557 69.4525 23.2559 69.4525 21.1312C69.4525 19.0065 68.1473 17.3067 65.9315 17.3067C63.8372 17.3067 62.4713 18.9154 62.4713 21.1312C62.4713 23.347 63.8372 24.9557 65.9315 24.9557Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M81.7489 28.0571C81.7489 28.2835 81.7489 28.3967 81.6786 28.467C81.6083 28.5373 81.4951 28.5373 81.2687 28.5373H77.5852C77.3588 28.5373 77.2456 28.5373 77.1753 28.467C77.1049 28.3967 77.1049 28.2835 77.1049 28.0571V14.3874C77.1049 14.161 77.1049 14.0478 77.1753 13.9775C77.2456 13.9072 77.3588 13.9072 77.5852 13.9072H81.3324C81.4975 13.9072 81.5801 13.9072 81.6398 13.9461C81.6679 13.9643 81.6918 13.9883 81.7101 14.0163C81.7489 14.0761 81.7489 14.1586 81.7489 14.3237C81.7489 14.8966 81.7489 15.183 81.828 15.2545C81.8705 15.2929 81.901 15.307 81.9577 15.3145C82.0634 15.3284 82.3096 15.1191 82.8018 14.7004C83.7179 13.9213 84.9741 13.5126 86.484 13.5126C90.0353 13.5126 91.8261 15.5159 91.8261 19.4921V28.0571C91.8261 28.2835 91.8261 28.3967 91.7558 28.467C91.6855 28.5373 91.5723 28.5373 91.3459 28.5373H87.632C87.4056 28.5373 87.2924 28.5373 87.2221 28.467C87.1518 28.3967 87.1518 28.2835 87.1518 28.0571V21.0098C87.1518 18.5512 86.4537 17.4281 84.5718 17.4281C82.7202 17.4281 81.7489 18.6422 81.7489 20.8884V28.0571Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M99.3097 28.0571C99.3097 28.2835 99.3097 28.3967 99.2394 28.467C99.169 28.5373 99.0558 28.5373 98.8294 28.5373H95.1763C94.9499 28.5373 94.8367 28.5373 94.7664 28.467C94.696 28.3967 94.696 28.2835 94.696 28.0571V14.3874C94.696 14.161 94.696 14.0478 94.7664 13.9775C94.8367 13.9072 94.9499 13.9072 95.1763 13.9072H98.8294C99.0558 13.9072 99.169 13.9072 99.2394 13.9775C99.3097 14.0478 99.3097 14.161 99.3097 14.3874V28.0571Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M110.007 24.9253C110.332 24.9253 110.718 24.9133 111.065 24.8891C111.33 24.8707 111.463 24.8615 111.539 24.9327C111.616 25.0039 111.616 25.1319 111.616 25.388V28.1365C111.616 28.3294 111.616 28.4258 111.557 28.4935C111.498 28.5612 111.406 28.5746 111.22 28.6014C110.552 28.6981 109.618 28.7801 108.52 28.7801C106.334 28.7801 103.329 28.2945 103.329 23.4077V18.0602C103.329 17.8338 103.329 17.7206 103.259 17.6502C103.189 17.5799 103.075 17.5799 102.849 17.5799H101.503C101.276 17.5799 101.163 17.5799 101.093 17.5096C101.022 17.4392 101.022 17.326 101.022 17.0996V14.3874C101.022 14.161 101.022 14.0478 101.093 13.9775C101.163 13.9072 101.276 13.9072 101.503 13.9072H102.849C103.075 13.9072 103.189 13.9072 103.259 13.8369C103.329 13.7665 103.329 13.6533 103.329 13.4269V10.047C103.329 9.82057 103.329 9.70738 103.4 9.63704C103.47 9.56671 103.583 9.56671 103.809 9.56671H107.493C107.719 9.56671 107.833 9.56671 107.903 9.63704C107.973 9.70738 107.973 9.82057 107.973 10.047V13.4269C107.973 13.6533 107.973 13.7665 108.044 13.8369C108.114 13.9072 108.227 13.9072 108.453 13.9072H110.801C111.028 13.9072 111.141 13.9072 111.211 13.9775C111.282 14.0478 111.282 14.161 111.282 14.3874V17.0996C111.282 17.326 111.282 17.4392 111.211 17.5096C111.141 17.5799 111.028 17.5799 110.801 17.5799H108.453C108.227 17.5799 108.114 17.5799 108.044 17.6502C107.973 17.7206 107.973 17.8338 107.973 18.0602V22.4364C107.973 24.5914 108.853 24.9253 110.007 24.9253Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M127.573 20.4634C127.573 21.0798 127.553 21.4959 127.496 22.0696C127.477 22.2716 127.467 22.3726 127.398 22.4348C127.329 22.4971 127.227 22.4971 127.022 22.4971H117.149C116.908 22.4971 116.787 22.4971 116.715 22.5826C116.643 22.6681 116.662 22.778 116.7 22.9977C116.976 24.5888 118.2 25.4413 120.076 25.4413C121.347 25.4413 122.209 25.1278 122.66 24.4149C122.753 24.2687 122.799 24.1956 122.853 24.1659C122.907 24.1361 122.979 24.1361 123.123 24.1361H126.798C127.064 24.1361 127.197 24.1361 127.269 24.2312C127.341 24.3262 127.308 24.4459 127.241 24.6851C126.519 27.2599 123.709 28.9319 120.076 28.9319C115.098 28.9319 112.032 26.1091 112.032 21.2223C112.032 16.4265 115.158 13.5126 119.924 13.5126C124.477 13.5126 127.573 16.3354 127.573 20.4634ZM116.685 19.127C116.653 19.3403 116.637 19.4469 116.709 19.5302C116.781 19.6135 116.899 19.6135 117.134 19.6135H122.502C122.736 19.6135 122.853 19.6135 122.925 19.5328C122.997 19.452 122.984 19.3435 122.957 19.1266C122.762 17.4989 121.695 16.639 119.894 16.639C118.078 16.639 116.91 17.6114 116.685 19.127Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M94.1497 9.08441C94.1497 10.6324 95.3335 11.9072 97.0029 11.9072C98.6723 11.9072 99.8864 10.6324 99.8864 9.08441C99.8864 7.50606 98.6723 6.23123 97.0029 6.23123C95.3335 6.23123 94.1497 7.50606 94.1497 9.08441Z"
                    className={igniteLogoClasses.colorPrimary}
                />
            </g>
        </svg>
    );
}

const Full = styled(FullSvgComponent, {
    shouldForwardProp(propName) {
        return propName !== "size" && propName !== "variant" && propName !== "color" && propName !== "sx";
    },
})<IgniteLogoOwnProps>({
    variants: [
        {
            props: { size: "xsmall" },
            style: {
                height: "1.5rem",
            },
        },
        {
            props: { size: "small" },
            style: {
                height: "2rem",
            },
        },
        {
            props: { size: "medium" },
            style: {
                height: "2.5rem",
            },
        },
        {
            props: { size: "large" },
            style: {
                height: "3rem",
            },
        },
        {
            props: { size: "xlarge" },
            style: {
                height: "3.5rem",
            },
        },
        {
            props: { size: "2xlarge" },
            style: {
                height: "4rem",
            },
        },
        {
            props: { color: "brand" },
            style: {
                [`.${igniteLogoClasses.colorPrimary}`]: {
                    fill: "#FE5C45",
                },
                [`.${igniteLogoClasses.colorSecondary}`]: {
                    fill: "#151D4C",
                },
            },
        },
        {
            props: { color: "secondary" },
            style: (t) => ({
                [`.${igniteLogoClasses.colorPrimary}, .${igniteLogoClasses.colorSecondary}`]: {
                    fill: t.theme.palette.text.textPrimary,
                },
            }),
        },
    ],
});

function SymbolSvgComponent(props: SVGProps<SVGSVGElement>): React.ReactNode {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 40" fill="none" {...props}>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <title>Ignite</title>
            <g className={igniteLogoClasses.icon}>
                <path
                    d="M20.7617 13.3083C24.4342 13.3083 27.4114 10.3291 27.4114 6.65414C27.4114 2.97916 24.4342 0 20.7617 0C17.0892 0 14.112 2.97916 14.112 6.65414C14.112 10.3291 17.0892 13.3083 20.7617 13.3083Z"
                    className={igniteLogoClasses.colorPrimary}
                />
                <path
                    d="M26.6768 21.2945C26.6768 22.2317 26.6768 22.6988 26.8514 23.1207C27.0261 23.5426 27.3544 23.8711 28.0169 24.5341C28.8783 25.396 29.589 26.1075 30.8418 27.3612C31.4532 27.973 31.7604 28.2804 31.9772 28.416C33.3144 29.2598 35.0822 28.5275 35.4316 26.9845C35.4888 26.7343 35.4888 26.3004 35.4888 25.4355C35.4888 25.0346 35.4888 24.8327 35.5129 24.664C35.6605 23.6665 36.4435 22.8859 37.4373 22.7382C37.606 22.7141 37.8048 22.7141 38.2083 22.7141C39.0757 22.7141 39.5063 22.7141 39.7563 22.6569C41.2983 22.3073 42.0301 20.5383 41.1868 19.2002C41.0513 18.9832 40.7441 18.6789 40.1328 18.0641L37.3109 15.24C36.6483 14.577 36.3171 14.2455 35.8984 14.0737C35.4768 13.899 35.01 13.899 34.0734 13.899H31.2575C29.0981 13.899 28.02 13.899 27.3484 14.571C26.6768 15.243 26.6768 16.3219 26.6768 18.4827V21.3005V21.2945Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M14.865 17.1295C14.865 16.1923 14.865 15.7252 14.6903 15.3033C14.5157 14.8813 14.1874 14.5529 13.5248 13.8899C12.6635 13.0279 11.9528 12.3165 10.7 11.0628C10.0886 10.451 9.7814 10.1436 9.56456 10.008C8.22738 9.16419 6.45954 9.89651 6.11019 11.4395C6.05297 11.6896 6.05297 12.1236 6.05297 12.9885C6.05297 13.3893 6.05297 13.5912 6.02888 13.76C5.88131 14.7575 5.09828 15.5381 4.10443 15.6857C3.93578 15.7098 3.73701 15.7098 3.33345 15.7098C2.46609 15.7098 2.03542 15.7098 1.78545 15.7671C0.243488 16.1167 -0.488345 17.8857 0.354919 19.2238C0.490443 19.4407 0.797632 19.7451 1.409 20.3599L4.23085 23.184C4.89341 23.847 5.2247 24.1785 5.64332 24.3502C6.06495 24.525 6.53175 24.525 7.46838 24.525H10.2843C12.4436 24.525 13.5218 24.525 14.1934 23.853C14.865 23.1809 14.865 22.1021 14.865 19.9413V17.1235V17.1295Z"
                    className={igniteLogoClasses.colorSecondary}
                />
                <path
                    d="M18.6868 25.1248C17.7502 25.1248 17.2834 25.1248 16.8617 25.2996C16.4401 25.4744 16.1118 25.8029 15.4493 26.4659C14.5879 27.3278 13.8772 28.0393 12.6244 29.2929C12.013 29.9047 11.7058 30.2121 11.5703 30.4291C10.727 31.7672 11.4589 33.5362 13.0008 33.8858C13.2508 33.943 13.6845 33.943 14.5488 33.943C14.9494 33.943 15.1512 33.943 15.3198 33.9671C16.3167 34.1148 17.0967 34.8983 17.2443 35.8928C17.2684 36.0616 17.2684 36.2605 17.2684 36.6643C17.2684 37.5323 17.2684 37.9632 17.3256 38.2134C17.6749 39.7563 19.4428 40.4887 20.78 39.6448C20.9968 39.5092 21.301 39.2018 21.9153 38.5901L24.7372 35.766C25.3998 35.103 25.731 34.7715 25.9027 34.3526C26.0774 33.9307 26.0774 33.4636 26.0774 32.5263V29.7086C26.0774 27.5478 26.0774 26.4689 25.4058 25.7969C24.7342 25.1248 23.656 25.1248 21.4967 25.1248H18.6808H18.6868Z"
                    className={igniteLogoClasses.colorSecondary}
                />
            </g>
        </svg>
    );
}

const SymbolOnly = styled(SymbolSvgComponent, {
    shouldForwardProp(propName) {
        return propName !== "size" && propName !== "variant" && propName !== "color" && propName !== "sx";
    },
})<IgniteLogoOwnProps>({
    variants: [
        {
            props: { size: "xsmall" },
            style: {
                height: "1.5rem",
            },
        },
        {
            props: { size: "small" },
            style: {
                height: "2rem",
            },
        },
        {
            props: { size: "medium" },
            style: {
                height: "2.5rem",
            },
        },
        {
            props: { size: "large" },
            style: {
                height: "3rem",
            },
        },
        {
            props: { size: "xlarge" },
            style: {
                height: "3.5rem",
            },
        },
        {
            props: { size: "2xlarge" },
            style: {
                height: "4rem",
            },
        },
        {
            props: { color: "brand" },
            style: {
                [`.${igniteLogoClasses.colorPrimary}`]: {
                    fill: "#FE5C45",
                },
                [`.${igniteLogoClasses.colorSecondary}`]: {
                    fill: "#151D4C",
                },
            },
        },
        {
            props: { color: "secondary" },
            style: (t) => ({
                [`.${igniteLogoClasses.colorPrimary}, .${igniteLogoClasses.colorSecondary}`]: {
                    fill: t.theme.palette.text.textPrimary,
                },
            }),
        },
    ],
});

interface IgniteLogoProps extends IgniteLogoOwnProps, Omit<SVGProps<SVGSVGElement>, "color"> {
    sx?: SxProps<Theme>;
}

function IgniteLogo(props: IgniteLogoProps): React.ReactNode {
    const { variant = "full", size = "medium", color = "brand", ...rest } = props;
    const className = [rest.className, igniteLogoClasses.root].filter(Boolean).join(" ");
    if (variant === "symbol") {
        return <SymbolOnly {...rest} size={size} color={color} className={className} />;
    }
    return <Full {...rest} size={size} color={color} className={className} />;
}

export { IgniteLogo };
